
export default function FormInfoCard({editFlag, setInfo, label, val}) {
  return (
    <div dir='rtl' style={{display:"flex", flexDirection:"row",  width:"fit-content", minWidth:"400px", height:"70px",alignItems:"center", justifyContent:"space-between", fontSize:"20px", margin:"10px auto"}}>
        <label style={{fontWeight:"bold", marginLeft:"20px"}}>{label}</label>
        {editFlag ? <input type="text" value={val} style={{width:"250px", height:"35px", fontSize:"20px", textAlign:"end"}} onChange={(e)=>{setInfo(e.target.value)}}/> : <p style={{margin:"0"}}>{val}</p>}
    </div>
  )
}
